module.exports = __webpack_public_path__ + "img/ouro.214f36da.png";